module.exports = __webpack_public_path__ + "img/0813d71.svg";